import { TableBody } from "react-aria-components";

import { Badge2 } from "@/ui2/atoms/Badge";
import { Cell2 } from "@/ui2/atoms/(table)/Cell";
import ChevronIcon from "@/assets/images/icons2/icon--chevron.svg?component";
import { EmptyTable } from "@/ui2/molecules/(table)/EmptyTable";
import { Link2 } from "@/ui2/atoms/Link";
import { Row2 } from "@/ui2/molecules/(table)/Row";
import { Table2 } from "@/ui2/atoms/(table)/Table";

import type { AdaptedDraftNote } from "../helpers/adapter";

import { DraftNotesTableHeader } from "./DraftNotesTableHeader";
import { DraftNotesTableSkeleton } from "./DraftNotesTableSkeleton";

type Props = {
  isLoading: boolean;
  rows: AdaptedDraftNote[];
};

export function DraftNotesTable({ isLoading, rows }: Props) {
  return (
    <Table2 aria-label="Draft notes">
      <DraftNotesTableHeader />
      {isLoading ? (
        <DraftNotesTableSkeleton />
      ) : (
        <TableBody items={rows} renderEmptyState={() => <EmptyTable message="No draft notes" />}>
          {(row) => (
            <Row2 id={row.id}>
              <Cell2 data-private>{row.name}</Cell2>

              <Cell2>
                {row.noteState === "rejected" && (
                  <Badge2 appearance="outline" size="xs" variant="error">
                    Returned
                  </Badge2>
                )}
              </Cell2>

              <Cell2>{row.dateOfService}</Cell2>
              <Cell2>{row.lastUpdated}</Cell2>

              <Cell2>
                <Link2 href={`/app/patient/${row.patientId}/note/${row.id}/v2`}>
                  <ChevronIcon aria-hidden className="tw:-rotate-90 tw:text-fill-teal-primary" />
                </Link2>
              </Cell2>
            </Row2>
          )}
        </TableBody>
      )}
    </Table2>
  );
}
